import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { DateUtils } from '@/utils/DateUtils';
import { MoneyUtils } from '@/utils/MoneyUtils';
import { PayoutSummary } from '@/interfaces/PayoutSummary';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutSummary',
  props: {
  consultations: {
    type: Array as () => PayoutSummary[],
    required: true
  }
},
  setup(__props) {

const props = __props;

const computedConsultations = computed(() =>
  props.consultations.map(c => ({
    ...c,
    patientFullName: `${c.patientLastName ?? ''} ${c.patientFirstName ?? ''}`.toLowerCase()
  }))
);

const filters = ref({
  patientFullName: { value: null, matchMode: 'contains' }
});

const loading = ref(false);

const safeDisplay = (value: string): string => value || '';

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: computedConsultations.value,
      filters: filters.value,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filters).value = $event)),
      filterDisplay: "row",
      loading: loading.value,
      paginator: true,
      rows: 5,
      rowsPerPageOptions: [5, 10, 20, 50],
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      currentPageReportTemplate: "Afișare {first} - {last} din {totalRecords} consultări",
      size: "small",
      dataKey: "consultationId",
      class: "p-datatable-sm",
      sortField: "consultationDate",
      sortOrder: -1
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          header: "Pacient",
          field: "patientFullName",
          sortable: "",
          showFilterMenu: false
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(safeDisplay(data.patientFirstName)) + " " + _toDisplayString(safeDisplay(data.patientLastName)), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              type: "text",
              onInput: ($event: any) => (filterCallback()),
              class: "p-column-filter",
              placeholder: "Caută pacient"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Data",
          field: "consultationDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.consultationDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Valoare",
          field: "consultationAmount",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(MoneyUtils).format(data.consultationAmount, data.currency || 'RON')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "filters", "loading"])
  ]))
}
}

})